<template>
    <tr>
        <td class="py-4 pl-6 whitespace-no-wrap border-b border-gray-200">
            <div class="flex-shrink-0 w-10 h-10">
                <user-avatar :user="member.user" class="object-cover w-8 h-8 text-gray-600 rounded-full fill-current" />
            </div>
        </td>
        <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
            <div class="flex items-center">
                <div>
                    <div class="text-sm font-medium leading-5 text-gray-900">{{ member.user.full_name }}</div>
                    <div class="text-sm leading-5 text-gray-500">{{ member.user.email }}</div>
                </div>
            </div>
        </td>
        <td class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200">{{ member.role.replace(/\b\w/, v => v.toUpperCase()) }}</td>
        <td class="relative px-6 py-4 text-sm font-medium leading-5 text-right whitespace-no-wrap border-b border-gray-200">
            <modify-org-user :member="member" />
        </td>
    </tr>
</template>

<script>
import UserAvatar from '@/components/UserAvatar';
import ModifyOrgUser from '@/components/ModifyOrgUser';

export default {
    name: 'org-memeber',
    props: {
        member: Object,
    },
    components: { UserAvatar, ModifyOrgUser },
};
</script>
